// LoadingSkeleton.js
import React from 'react';

const LoadingSkeleton = () => {
  return (
    <div className="loading-skeleton-container">
      {[...Array(4)].map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-image"></div>
          <div className="skeleton-content">
            <div className="skeleton-rating"></div>
            <div className="skeleton-title"></div>
            <div className="skeleton-title short"></div>
            <div className="skeleton-price"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;